// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b22872da","587":"f0d4a25d","673":"4536b035","787":"d16d0675","830":"2fdeaf46","989":"299b6da1"}[chunkId] + ".chunk.js";
};